import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import Cookies from 'js-cookie';
import { refreshToken } from '../../../../Redux/Auth/authActions';
import { partnerPortalApi } from '../Services/partnerPortalApi';
import { resolveAccessToken, usePartnerAccessToken } from './usePartnerAccessToken';

const isUnauthorizedError = (error) => {
  const message = (error?.message || '').toLowerCase();
  return message.includes('unauthorized') || message.includes('authentication');
};

export const usePartnerProjectDetails = (projectId) => {
  const dispatch = useDispatch();
  const accessToken = usePartnerAccessToken();
  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadProject = useCallback(async () => {
    if (!projectId) {
      setProject(null);
      setLoading(false);
      return;
    }

    const token = resolveAccessToken(accessToken);
    if (!token) {
      setProject(null);
      setLoading(false);
      setError('Your session has expired. Please sign in again.');
      return;
    }

    setLoading(true);
    setError(null);

    const fetchProject = async (activeToken) => {
      const data = await partnerPortalApi.fetchProjectById(activeToken, projectId);
      setProject(data);
    };

    try {
      await fetchProject(token);
    } catch (err) {
      if (isUnauthorizedError(err) && Cookies.get('refreshToken')) {
        try {
          await dispatch(refreshToken());
          const refreshedToken = Cookies.get('accessToken');
          if (refreshedToken) {
            await fetchProject(refreshedToken);
            return;
          }
        } catch (refreshError) {
          setError(refreshError.message || err.message);
          setProject(null);
          return;
        }
      }

      setError(err.message);
      setProject(null);
    } finally {
      setLoading(false);
    }
  }, [accessToken, dispatch, projectId]);

  useEffect(() => {
    loadProject();
  }, [loadProject]);

  return {
    project,
    loading,
    error,
    refreshProject: loadProject,
    setProject,
  };
};
